/* global moment */
(function () {
    'use strict';

    angular
        .module('app')
        .controller('WinbackOffersAddController', WinbackOffersAddController);

    WinbackOffersAddController.$inject = ['$stateParams', '$scope', '$state', 'API', 'i18n',];

    function WinbackOffersAddController($stateParams, $scope, $state, API, i18n) {
        $scope.$state = $state;
        var vm = this;
        vm.isAdding = false;
        vm.add = add;
        vm.offer = {
            type: 'regular',
            bonus_type: 'time',
            amount_currency: 'SEK',
            translations: {},
        };
        vm.subscriptionPlans = [];
        vm.loadingState = {
            subscriptionPlans: false,
        };

        activate();

        function activate() {
            loadSubscriptionPlans();
        }

        function loadSubscriptionPlans() {
            vm.loadingState.subscriptionPlans = true;
            API.SubscriptionPlan.search({ provider: 'Stripe', 'per-page': -1 }).$promise.then(function (response) {
                angular.extend(vm.subscriptionPlans, response.items);

                vm.loadingState.subscriptionPlans = false;
            }, function () {
            });
        }

        function add() {
            var offer = angular.copy(vm.offer);

            if (offer.valid_from) {
                offer.valid_from = moment(offer.valid_from).format('YYYY-MM-DD 00:00:00');
            }

            if (offer.valid_to) {
                offer.valid_to = moment(offer.valid_to).format('YYYY-MM-DD 23:59:59');
            }

            if (offer.amount && typeof offer.amount.getDay === 'function') {
                offer.amount = moment(offer.amount).format('YYYY-MM-DD 23:59:59');
            }

            if (!vm.isAdding) {
                vm.isAdding = true;

                var newOffer = new API.WinbackOffer(offer);

                var promise = newOffer.$save();

                promise.then(function (response) {
                    window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
                    $state.go('winbackOffers.edit', { id: response.id });
                }, function () {
                })
                    .finally(function () {
                        vm.isAdding = false;
                    });
            }
        }
    }
})();